import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/ThemePark/reports/CancelledQueueReport/CancelledQueueReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class CancelledQueueReportActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/ThemePark/reports/CancelledQueueReport/CancelledQueueReport")
	}

	render() {
		return (
			<Activity 
				name="CancelledQueueReport"
				RenderedComponent={this.RenderedComponent}
				context="CancelledQueueReport"
				action="CancelledQueueReport"
				formActions={FormAction}/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(CancelledQueueReportActivity)